import React from 'react'
import PropTypes from 'prop-types'

const FileConversionRequestTitle = ({ itemUrl, itemTitle }) => (
  <div>
    File format conversion request:
    <a href={itemUrl} className="u-ml10">{itemTitle}</a>
  </div>
)

FileConversionRequestTitle.propTypes = {
  itemUrl: PropTypes.string.isRequired,
  itemTitle: PropTypes.string.isRequired,
}

export default FileConversionRequestTitle
